// Entry Form 用のベース項目を解決します。
// type=0 は VIEW 用のため対象外にし、type>=100 の項目だけを採用します。

function canonicalPanelType(type) {
    if (type === null || type === undefined) return "";
    const s = String(type).trim();
    const low = s.toLowerCase();
    if (low === "20" || low === "130" || low === "jutyusu") return "130";
    if (low === "21" || low === "131" || low === "nouhinyotei") return "131";
    return s;
}

function isEntryType(type) {
    const num = Number(canonicalPanelType(type));
    return Number.isFinite(num) && num >= 100;
}

export function buildEntryBaseFields(layoutColumns, allColInfo, options) {
    const {
        baseLogpid,
        fukushizaiBasePanelType,
        traceabilityPanelType,
        sustainableReserveFields,
        isFukushizaiContextField,
        applyDesignReadonlyToField,
        isEmpty,
        DicVal,
        cellTypeCheck
    } = options;

    const safeLayoutColumns = Array.isArray(layoutColumns) ? layoutColumns.filter((item) => isEntryType(DicVal(item, "type", ""))) : [];
    const safeColInfo = Array.isArray(allColInfo) ? allColInfo.filter((item) => isEntryType(DicVal(item, "type", ""))) : [];

    const seen = new Set();
    const baseFields = safeLayoutColumns.filter((field) => {
        const typeKey = canonicalPanelType(DicVal(field, "type", ""));
        const logpid = String(DicVal(field, "logpid", "") ?? "").trim();

        // Entry Form のベース項目は logpid=0 を基本とし、
        // 副資材(113)だけは既存互換のため例外的に残します。
        if (!(logpid === baseLogpid || typeKey === fukushizaiBasePanelType)) return false;
        if (typeKey === fukushizaiBasePanelType && isFukushizaiContextField(DicVal(field, "columnid", ""))) return false;

        const dedupeKey = `${typeKey}::${String(DicVal(field, "columnid", "") ?? "").trim().toUpperCase()}`;
        if (seen.has(dedupeKey)) return false;
        seen.add(dedupeKey);
        return true;
    });

    const reserveFieldIds = new Set((Array.isArray(sustainableReserveFields) ? sustainableReserveFields : []).map((fieldId) =>
        String(fieldId ?? "").trim().toUpperCase()
    ));

    safeColInfo.forEach((field) => {
        if (isEmpty(field)) return;
        if (canonicalPanelType(DicVal(field, "type", "")) !== traceabilityPanelType) return;
        if (String(DicVal(field, "logpid", "") ?? "").trim() !== baseLogpid) return;

        // 129 は GetListTabs.columns に載らない予備項目があるため、
        // colinfo から必要項目だけ補完します。
        const columnId = String(DicVal(field, "columnid", "") ?? "").trim().toUpperCase();
        if (!reserveFieldIds.has(columnId)) return;

        const dedupeKey = `${traceabilityPanelType}::${columnId}`;
        if (seen.has(dedupeKey)) return;
        baseFields.push({ ...field });
        seen.add(dedupeKey);
    });

    return baseFields.map((field) => {
        if (isEmpty(field)) return field;
        const typeKey = canonicalPanelType(DicVal(field, "type", ""));
        const columnIdKey = String(DicVal(field, "columnid", "") ?? "").trim().toUpperCase();
        const info = safeColInfo.find((col) =>
            canonicalPanelType(DicVal(col, "type", "")) === typeKey &&
            String(DicVal(col, "columnid", "") ?? "").trim().toUpperCase() === columnIdKey
        );
        if (isEmpty(info)) return applyDesignReadonlyToField(field);

        const merged = { ...field };
        const systemDrivenKeys = [
            "datatype", "decimalplace", "options",
            "locked", "primary", "primarykey", "unchange", "required", "saveed", "multiple",
            "length", "format", "dataid", "dbcolumn", "dbcolumnnm", "keyinfo",
            "searchparam", "history", "copyclear", "extrigger", "extriggerref", "trigger"
        ];
        systemDrivenKeys.forEach((key) => {
            if (key in info) merged[key] = info[key];
        });
        if (isEmpty(merged.columnnm) && !isEmpty(info.columnnm)) merged.columnnm = info.columnnm;

        if (columnIdKey === "SSDQ_SUB_SOSEICD" || columnIdKey === "SSDQNR_SUBSOSEICD1") {
            const normalizedDataId = String(merged.dataid ?? "").trim();
            const normalizedMasterType = String(merged.mastertype ?? "").trim();
            const normalizedDataIdCtrl = String(merged.dataidctrl ?? "").trim();
            const inferredDataId = normalizedDataId || normalizedMasterType || normalizedDataIdCtrl;
            if (normalizedDataId === "" && inferredDataId !== "") merged.dataid = inferredDataId;
            if (normalizedMasterType === "" && inferredDataId !== "") merged.mastertype = inferredDataId;
        }

        // 副資材の仕入先公開はチェックボックスで扱う(s_layoutはテキスト定義のまま画面側で寄せる)。
        if (columnIdKey === "SSDZ_SHIIREPOENF" && !isEmpty(cellTypeCheck)) {
            merged.datatype = cellTypeCheck;
        }
        return applyDesignReadonlyToField(merged);
    });
}
